<template>
    <div class="main-content">
        <div class="main-portal">
            <div class="main-avatar">
            </div>
            <div class="main-avatar2">
            </div>
            <div class="main-avatar3">
            </div>
            <div class="main-avatar4" v-if="company"  @click="visual(company.office)">
                <img v-if="company.office.image_office.length!=0" :src="company.office.image_office[company.office.image_office.length-1].link" alt="" srcset="">
                <img v-else :src="imageUrl" alt="" srcset="">               
            </div>
            <div  v-else >
                <img :src="imageUrl" alt="" srcset="">
            </div>
        </div>
        <div class="main-container">
            <!--Foto de perfil-->
            <div class="main-perfil">
                <div class="J-content-center J-content-center-c J-content-color" @click="visual(company)" style="z-index: 0;cursor:pointer">
                    <h1 class="J-title-primary">
                        {{company.name}}
                    </h1>
                    <h2 class="J-title-secundary">
                         {{company.office.name}}
                    </h2>
                </div>
                <div class="item-perfil">
                    <img v-if="company&&company.image_company" :src="company.image_company.link" alt="" srcset="">
                    <img v-else :src="imageUrl" alt="" srcset="">
                </div>
                
            </div>
            <!--Botones de perfil-->
            <div class="main-container-btn">
                <button class="item" v-for="(tab,i) in tabs" :key="i+1" @click="action(i)"  :class="{'active':tab.active}" v-show="tab.visible">{{tab.title}}</button>
                <button class="J-btn-primary color-primary default J-m-l-20" @click="modal_subscription=true" v-if="false"><i class="fas fa-star"></i><span class="J-m-l-10">Suscribirse</span></button>
                <button class="J-btn-primary color-primary default" v-if="false"><i class="fas fa-comment"></i><span class="J-m-l-10">Mensaje</span></button>
                <button class="J-btn-primary color-primary default" v-if="false"><i class="fas fa-heart"></i></button>
            </div>
        </div>
        <subscription-modal :modal="modal_subscription" :info="company" @modal="modal_subscription=$event"/>
    </div>
</template>
<script>

//@click="modal_subscription=true"
    import SubscriptionModal from '@/components/modals/subscription.modal'
    export default {
        data:()=>({
            modal_subscription:false,
            imageUrl: 'https://picsum.photos/510/300?random',
            tabs:[
                {
                    title:"Productos",
                    active:true,
                    visible:true
                },
                {
                    title:"Cupones",
                    active:false,
                    visible:false
                },
                {
                    title:"Acerca de...",
                    active:false,
                    visible:true
                }
            ]
        }),
        components:{
            SubscriptionModal
        },
        methods:{
            visual(data){
                try{
                    if(data.image_company){
                        this.$emit('visual',(data.image_company.link))
                    }
                    if(data.image_office){
                        this.$emit('visual',data.image_office[data.image_office.length-1].link)
                    }
                }
                catch(err){
                    this.$emit('visual',(this.imageUrl))
                }
            },
            action(i){
                var data=this.tabActive(this.tabs,i);
                this.tabs=data;
                this.$emit('action',data)
            }
        },
        props:{
            company:{required:false,default:null}
        }
    }
</script>